import i18n from 'i18n-js';
import React from 'react';
import {ConfirmLogInScreen} from './ConfirmLogInScreen';
import {LogInScreen} from './LogInScreen';
import {AuthNav, Stack} from './navigation';

type Props = {};

export const authStackLinking = {
  initialRouteName: AuthNav.LogInScreen,
  screens: {
    [AuthNav.LogInScreen]: 'login',
    [AuthNav.ConfirmLogInScreen]: 'confirm-login'
  }
};

export const AuthScreens: React.FC<Props> = () => {
  return (
    <Stack.Navigator
      initialRouteName={AuthNav.LogInScreen}
      screenOptions={{
        headerShown: false,
        animationEnabled: false
      }}>
      <Stack.Screen
        name={AuthNav.LogInScreen}
        options={{title: i18n.t('logIn')}}
        component={LogInScreen}
      />
      <Stack.Screen
        name={AuthNav.ConfirmLogInScreen}
        options={{title: i18n.t('verificationCode')}}
        component={ConfirmLogInScreen}
      />
    </Stack.Navigator>
  );
};
